import { Skeleton } from '@modulor/react';
import clx from 'classnames';
import React from 'react';

import SkeletonArray from '../SkeletonArray';
import style from './SkeletonInitPage.module.scss';

const SkeletonInitPage = () => (
  <>
    <div className={style.title}>
      <Skeleton width={120} height={16} borderRadius={100} marginBottom={18} />
    </div>
    <div className={clx(style.listWrapper, style.mobile)}>
      <SkeletonArray length={6}>
        <Skeleton width="100%" height={8} borderRadius={100} marginBottom={16} />
      </SkeletonArray>
    </div>
  </>
);

export default SkeletonInitPage;
